import React, { Component } from 'react'
import Header from '../components/Header'
import SearchItem from '../components/SearchItem'
import SaveReset from '../components/SaveReset'
import Swal from 'sweetalert2'
import '../assets/css/main.scss'
import PlusIcon from '../assets/img/icon/plus_black.svg'
import LibraryList from '../components/LibraryList'
import { ReactSortable, Sortable, MultiDrag, Swap } from "react-sortablejs";
import KeywordDetail from '../components/KeywordDetail'
import commonMethod from '../lib/commonMethod'
import userMethod from '../lib/userMethod'
import $ from "jquery";
import * as requestLib from "../lib/requestLib"

class Main extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchList: [
                { id: "0", type: "Natural Language Search", keyword: [], condition: "editing", code: 1 },
                // {id:"4", type:"Related Keywords", keyword:[], keywordAll:[], condition:"waiting", code:2},
                // {id:"2", type:"Functions", keyword:[], keywordAll:[], condition:"waiting", code:3},
                // {id:"6", type:"Physical Effects", keyword:[], keywordAll:[], condition:"waiting", code:7},
                // {id:"5", type:"Products", keyword:[], keywordAll:[], condition:"waiting", code:6},
                // {id:"1", type:"Biological Systems", keyword:[], keywordAll:[], condition:"waiting", code:5},
                // {id:"3", type:"Research Papers", keyword:[], keywordAll:[], condition:"waiting", code:4},
            ],
            showLibrary: false,
            searchKeywordList: [],
            keywordDetail: false,
            beforeMoveList: null,
            libraryList: [],
            // user
            userId: null,
            accessToken: null,
            keywordClose: true,
        };

        this.libraryList = [];

        this.baseUrl = requestLib.getUrl();

    }

    componentDidMount() {
        this.setUser();


    }

    async setUser() {

        let accessToken = commonMethod.getCookie("accessToken");
        let url = window.location.href;
        let userId = "";
        let gr, si;

        if (url.indexOf("localhost") !== -1) {
            accessToken =
                '7f87269d9da7f139bb7b4841212b5cdc1dcb3a8a735ca891219ed633477ce959';
        }

        let isTest = false;
        // gr = '260';
        // si = 'Sy866WjN8nsfp';

        if (!isTest) {
            if (typeof url.split('gr=')[1] !== "undefined") {
                gr = url.split('gr=')[1].split('&')[0];
                si = url.split('si=')[1].split('&')[0];
            }
        }

        try {

            userId = await userMethod.checkPermission(accessToken);
            this.setState({ userId: userId, accessToken: accessToken });
            this.getLibraryList(userId, accessToken);
            if (gr && si) {
                this.getSearchList(accessToken, gr, si);
            }
        } catch (error) {
            console.log(error)
        }

    }

    getLibraryList(userId, accessToken) {

        let data = {
            session_id: userId,
            uniq_id: accessToken,
            data_set: {
                target_step_code: 0,
            }
        };

        commonMethod.requestStepSearch('https://d7ecgx9wn9.execute-api.us-west-1.amazonaws.com/step_search',
            data, res => {
                if (res.status_code === 200) {
                    this.setState({ libraryList: res.data })
                }
            })
    }

    addLibrary(type, id, code) {
        // console.log(type,id, code)

        let searchList = this.state.searchList;
        let makeId = new Date().getTime();

        let data = { id: makeId, type: type, keyword: [], keywordAll: [], condition: "waiting", isNew: true, code: code }

        if (type === "Natural Language Search") {
            delete data.keywordAll;
        }

        if (id) {
            let idx = searchList.findIndex(function (search) { return search.id === id })
            if (idx > -1) searchList.splice(idx + 1, 0, data);
        } else {
            if (searchList[searchList.length - 1].condition === "editable") {
                data.condition = "editing"
                if (searchList[searchList.length - 2]) searchList[searchList.length - 2].condition = "complete"
            }
            searchList.push(data)
        }

        this.setState({ searchList: searchList });
    }

    // 컨펌 버튼 누른 후 상태 저장
    addSearchKeyword(keyword, data) {

        let searchList = this.state.searchList;
        let searchKeywordList = this.state.searchKeywordList;

        // 검색어 추가
        searchKeywordList = searchKeywordList.concat(keyword)

        // 아이템 상태 변경
        let idx = searchList.findIndex(function (search) { return search.id === data.id })

        searchList[idx].keyword = keyword;
        searchList[idx].condition = "editable";
        if (searchList[idx + 1]) searchList[idx + 1].condition = "editing";
        else this.setState({ showLibrary: true })
        if (searchList[idx + 1] && searchList[idx - 1]) searchList[idx - 1].condition = "complete";

        this.setState({ searchKeywordList: searchKeywordList, searchList: searchList });
    }

    getSearchList(accessToken, gr, si) {
        if (gr && si) {
            const thisTarget = this;
            commonMethod.requestGet("api/Step/getInfo",
                {
                    groupId: gr,
                    uid: si,
                    userToken: accessToken,
                },
                function (res) {
                    if (res.data && res.data.info != null) {
                        let newSearchList = [];
                        res.data.info.map((v, k) => {
                            v.code = Number(v.code);
                            v.isLoad = true;
                            newSearchList[k] = v;
                        })
                        thisTarget.setState({ searchList: newSearchList })
                    }
                }
            )

        }
    }

    // 키워드 상세
    keywordDetail(e, keyword) {
        e.stopPropagation();

        this.setState({
            keywordDetail: keyword,
            keywordClose: false
        });
    }

    // 스텝 삭제
    deleteItem(data) {
        // console.log(data);

        let searchList = this.state.searchList;
        let idx = searchList.findIndex(function (search) { return search.id === data.id })

        if (data.condition === "complete") {
            // 완료 상태인 아이템일 경우 하위 컨펌된 아이템 삭제
            Swal.fire({
                title: 'Are you sure?',
                text: 'All the following steps will be deleted.',
                showCancelButton: true,
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel'
            }).then((result) => {
                if (result.value) {

                    searchList[idx - 1].condition = "editable";

                    let deleteArray = [];

                    for (let i = idx; i < searchList.length; i++) {
                        if (searchList[i].condition === "complete" || searchList[i].condition === "editable") {
                            deleteArray.push(i)
                        }
                    }

                    searchList.splice(idx, deleteArray.length);

                    this.setState({ searchList: searchList });

                }
            })
        } else if (data.condition === "editing" || data.condition === "editable") {
            // 수정가능한 아이템인 경우 삭제 후 하단 아이템 활성화
            if (idx > -1) searchList.splice(idx, 1);
            if (searchList[idx - 1]) searchList[idx - 1].condition = "editable";
            if (searchList[idx]) searchList[idx].condition = "editing";
            this.setState({ searchList: searchList });
        } else {
            // 검색 결과가 없는 아이템 삭제
            if (idx > -1) searchList.splice(idx, 1);
            this.setState({ searchList: searchList });
        }

        // this.setState({searchList:searchList});
    }

    editItem(data, keyword, keywordAll) {

        let searchList = this.state.searchList;
        let idx = searchList.findIndex(function (search) { return search.id === data.id })

        if (data.type === "Natural Language Search") {

        } else {
            if (searchList[idx]) {
                searchList[idx].keyword = keyword;
                searchList[idx].keywordAll = keywordAll;
            }
        }

        // 다음 스텝이 수정중일떄 새로 불러옴
        if (searchList[idx + 1] && searchList[idx + 1].condition == "editing") {
            // let newSearchList = searchList.pop();
            searchList[idx + 1].isReLoad = Math.random() * (10000 - 1) + 1;
            searchList[idx + 1].keyword = [];
            searchList[idx + 1].isLoad = false;
            this.setState({ searchList: searchList });

        }


        var targetIndex = this.getSearchIndex(data.id, searchList, "id");
        if (targetIndex <= -1) {
            this.clearKeyword(targetIndex);
        }

        this.setState({ searchList: searchList });

    }

    clearKeyword(index) {
        let searchList = this.state.searchList;
        for (var i = 0; i < searchList.length; i++) {
            if (i === index) {
                searchList[i].condition = "editing";
            } else if (i > index) {
                searchList[i].keyword = [];
                searchList[i].keywordAll = [];
                searchList[i].condition = "waiting";
            }
        }
        this.setState({ searchList: searchList });
    }

    getSearchIndex(value, arr, prop) {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][prop] == value) {
                return i;
            }
        }
        return -1;
    }

    onMoveStart(evt) {
        this.setState({ beforeMoveList: this.state.searchList })
    }

    onMoveEnd(evt) {

        // 자연어 검색 뒤에 자연어 검색 이동 불가

        let searchList = this.state.searchList
        let isContinuity = false;

        for (let i = 0; i < searchList.length; i++) {
            if (searchList[i].type && searchList[i].type === "Natural Language Search") {
                if (searchList[i + 1] && searchList[i + 1].type === "Natural Language Search") {
                    isContinuity = true;
                    break;
                }
            }
        }

        if (isContinuity) {
            Swal.fire({
                text: 'Natural language searches cannot be consecutive. Return to the previous list.',
                showClass: { popup: "swal2-one" },
                confirmButtonText: "OK",
            }).then((result) => {
                if (result.value) {
                    this.setState({ searchList: this.state.beforeMoveList })
                }
            })
        }

    }


    render() {

        let searchList = this.state.searchList;

        return (
            <React.Fragment>

                <Header />

                <div className="wrapB">
                    <div className="step-wrap">

                        <SaveReset searchList={this.state.searchList}
                            userId={this.state.userId} accessToken={this.state.accessToken}
                            resetSearch={() => this.setState({
                                searchList: [{ id: "0", type: "Natural Language Search", keyword: [], condition: "editing" }]
                            })} />

                        <ReactSortable list={searchList} setList={(newList) => this.setState({ searchList: newList })}
                            handle=".handle" ghostClass="move-class" draggable=".movable"
                            dragClass="drag-class"
                            onStart={(evt) => this.onMoveStart(evt)}
                            onEnd={(evt) => this.onMoveEnd(evt)}>
                            {searchList.map((v, k) => {
                                return (
                                    <SearchItem key={v.id} data={v} addLibrary={(type, id, code) => this.addLibrary(type, id, code)}
                                        addSearchKeyword={(keyword) => this.addSearchKeyword(keyword, v)}
                                        keywordDetail={(e, keyword) => this.keywordDetail(e, keyword)}
                                        deleteItem={() => this.deleteItem(v)}
                                        beforeItem={searchList[k - 1]}
                                        searchList={this.state.searchList}

                                        editItem={(data, keyword, keywordAll) => this.editItem(data, keyword, keywordAll)}
                                        userId={this.state.userId} accessToken={this.state.accessToken}
                                        libraryList={this.state.libraryList}
                                        key={v.isReLoad ? v.isReLoad : k} />
                                )
                            })}
                        </ReactSortable>

                        <div className={this.state.showLibrary ? "add-lib-wrap active" : "add-lib-wrap"}
                            onClick={() => this.setState({ showLibrary: !this.state.showLibrary })}>
                            <div className="wrap">
                                <img src={PlusIcon} />
                                <h4>Add for Next Step</h4>
                            </div>
                            {this.state.showLibrary &&
                                <LibraryList addLibrary={(type, id, code) => this.addLibrary(type, id, code)} searchList={this.state.searchList}
                                    last={true} userId={this.state.userId} libraryList={this.state.libraryList}
                                    accessToken={this.state.accessToken} />
                            }

                        </div>
                    </div>
                </div>

                <KeywordDetail keywordDetail={this.state.keywordDetail} close={this.state.keywordClose}
                    hideDetail={() => this.setState({ keywordClose: true })} />

            </React.Fragment>
        )
    }
}


export default Main;
